module.exports = __webpack_public_path__ + "static/media/litter_icon_selected.90bbd8ce.svg";